import { render, staticRenderFns } from "./PageImageList.vue?vue&type=template&id=ebf23810&scoped=true&"
import script from "./PageImageList.vue?vue&type=script&lang=js&"
export * from "./PageImageList.vue?vue&type=script&lang=js&"
import style0 from "./PageImageList.vue?vue&type=style&index=0&id=ebf23810&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf23810",
  null
  
)

export default component.exports